import HelpOutlineIcon from '@mui/icons-material/InfoOutlined'
import {
  Box,
  Card,
  CardContent,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import TooltipIcon from '../../../../components/TooltipIcon'
import Dot from '../../../../icons/Dot'
import { useTheme } from '../../../../theme'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const CustomTooltip = ({ active, payload }) => {
  const theme = useTheme()
  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          width: 180,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          borderRadius: 1.5,
        }}
      >
        <ListItem
          disablePadding
          secondaryAction={
            <ListItemText
              primaryTypographyProps={{
                variant: 'subtitle2',
                color: theme.palette.common.white,
              }}
              primary={payload[0].value}
            />
          }
        >
          <ListItemIcon sx={{ borderRadius: 100, p: 0 }}>
            <Dot sx={{ color: payload[0].fill, zIndex: 1, fontSize: 32 }} />
            <Dot
              sx={{
                position: 'absolute',
                zIndex: 0,
                color: '#ffffff',
                fontSize: 32,
              }}
            />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              variant: 'subtitle2',
              color: theme.palette.common.white,
              textTransform: 'capitalize',
            }}
            primary={payload[0].name}
          />
        </ListItem>
      </Box>
    )
  }

  return null
}

const SwipesChart = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { hour2Rows } = useCountersAnalyticsData()

  const dataArray = hour2Rows.map((row) => ({
    name: t(`newAnalytics.hour2.${row.label}`),
    swipes: row.value,
  }))

  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowX: 'scroll',
      }}
    >
      <Box sx={{ display: 'flex', p: 2 }}>
        <Typography color='inherit' variant='body2' textTransform={'uppercase'}>
          {t('stats.swipesByTimeOfDay')}
        </Typography>
        <Box sx={{ pl: 1 }}>
          <TooltipIcon
            text={t('stats.tooltips.swipesByTimeOfDay')}
            icon={
              <HelpOutlineIcon
                fontSize={'small'}
                sx={{ color: theme.palette.text.secondary }}
              />
            }
          />
        </Box>
      </Box>
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        <ResponsiveContainer width={'100%'} height={300} minWidth={550}>
          <BarChart
            data={dataArray}
            margin={{
              top: 5,
              right: 20,
              left: 0,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis
              dataKey='name'
              style={{
                fontFamily: theme.typography.fontFamily,
              }}
            />
            <YAxis
              style={{
                fontFamily: theme.typography.fontFamily,
              }}
            />
            <Tooltip content={CustomTooltip} />
            <Bar dataKey='swipes' name={t('stats.swipes')} fill='#5664D2' />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}

export default SwipesChart
